import { h } from 'preact';
export const ShoppingBag = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
        h("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
        h("path", { d: "M16 10a4 4 0 0 1-8 0" })));
};
//# sourceMappingURL=shopping-bag.js.map